import React, { useRef } from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import TransitionLink from "gatsby-plugin-transition-link"

import { gsap } from "gsap/all"
import { TYPE, COLORS } from "../../../../theme/styles/globals"

const Button = ({ label, action, link, mode, onClick, transition }) => {

  const tabRef = useRef(null)
  const labelRef = useRef(null)
  let DOM = null

  const onEnter = () => {
    gsap.to(tabRef.current, { width:`100%`, duration:.2, ease:`sine.easeOut` })
    gsap.to(labelRef.current, { color:mode === 'MENU' ? '#fff' : '#000', duration:.2, ease:`sine.easeOut` })
  }
  
  const onLeave = () => {
    gsap.to(tabRef.current, { width: 4, duration:.2, ease:`sine.easeOut` })
    gsap.to(labelRef.current, { color:mode === 'MENU' ? '#000' : '#fff', duration:.2, ease:`sine.easeOut` })
  }

  if(action === `INTERNAL`){
    DOM = (
      <WrapLink
        onMouseEnter={onEnter}
        onMouseLeave={onLeave}
        mode={mode}
        to={link}
        exit={transition.exit}
        entry={transition.entry}
      >
        <Label ref={labelRef}>{label}</Label>
        <Tab mode={mode} ref={tabRef} />
      </WrapLink>
    )
  }else if(action === `EXTERNAL`){
    DOM = (
      <a href={link} target="_blank">
        <Wrap
          onMouseEnter={onEnter}
          onMouseLeave={onLeave}
          mode={mode}
          to={link}
          exit={transition.exit}
          entry={transition.entry}
        >
          <Label ref={labelRef}>{label}</Label>
          <Tab mode={mode} ref={tabRef} />
        </Wrap>
      </a>
    )
  }else{
    DOM = (
      <Wrap
        onMouseEnter={onEnter}
        onMouseLeave={onLeave}
        mode={mode}
      >
        <Label ref={labelRef}>{label}</Label>
        <Tab mode={mode} ref={tabRef} />
      </Wrap>
    )
  }
  
  return DOM
}

export default Button

const WrapLink = styled(TransitionLink)`
  display:inline-flex;
  align-items:center;
  justify-content:center;
  height:50px;
  ${props => props.mode === 'LIGHT' ? `background-color:${COLORS.DARK_GREY_2};` : props.mode === 'DARK' ? `background-color:${COLORS.DARK_GREY_4};` : `background-color: #fff;`}
  padding-left:50px;
  padding-right:50px;
  position:relative;
  cursor:pointer;
`

const Wrap = styled.div`
  display:inline-flex;
  align-items:center;
  justify-content:center;
  height:50px;
  ${props => props.mode === 'LIGHT' ? `background-color:${COLORS.DARK_GREY_2};` : props.mode === 'DARK' ? `background-color:${COLORS.DARK_GREY_4};` : `background-color: #fff;`}
  padding-left:50px;
  padding-right:50px;
  ${props => props.mode === 'MENU' ? `width:192px;` : `width:auto;`}
  position:relative;
  cursor:pointer;
`

const Tab = styled.div`
  content:"";
  width:4px;
  height:100%;
  ${props => props.mode === 'LIGHT' ? `background-color:${COLORS.DARK_GREY_3};` : props.mode === 'DARK' ? `background-color:${COLORS.LIGHT_GREY_1};` : `background-color:#000;`}
  left:0px;
  position:absolute;
`

const Label = styled.span`
  font-family:${TYPE.MONO_FONT};
  ${props => props.mode === 'MENU' ? `color:#000;` : `color:#fff;`}
  font-size:14px;
  z-index:1;
`